import { render, staticRenderFns } from "./DadosPessoais.vue?vue&type=template&id=f40e6526&scoped=true&"
import script from "./DadosPessoais.vue?vue&type=script&lang=js&"
export * from "./DadosPessoais.vue?vue&type=script&lang=js&"
import style0 from "./DadosPessoais.vue?vue&type=style&index=0&id=f40e6526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40e6526",
  null
  
)

export default component.exports